import { ref } from 'vue'

type SystemMessage = {
  message: string
  date: string
  important?: boolean
}

const systemMessage = ref<SystemMessage>({ message: '', date: '' })
const isOpened = ref(false)

export function useSystemMessageToast() {
  const showSystemMessage = (newToast: SystemMessage) => {
    const timeoutDelay = isOpened.value ? 150 : 0

    isOpened.value = false

    setTimeout(() => {
      systemMessage.value = newToast
      isOpened.value = true
    }, timeoutDelay)
  }

  return { showSystemMessage, systemMessage, isOpened }
}
